import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  BaseText,
  FilterSelect,
  Row,
  SkeletonLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';

import {
  getCashbackDetails,
  ICashbackDetail,
  ISummaryV2
} from '@/modules/cash/services/costs';
import CashbackSideSheet from '@/modules/cash/views/Cashback/components/CashbackSideSheet/CashbackSideSheet.vue';
import { Money } from '@/modules/common/components/Money';


export default /*#__PURE__*/_defineComponent({
  __name: 'Cashback',
  setup(__props) {

const isLoading = ref(false);
const hasError = ref(false);
const selectedYear = ref('');
const selectedMonth = ref<ISummaryV2>({} as ISummaryV2);
const isSideSheetOpen = ref(false);
const availableYears = ref<string[] | null>(null);
const cashbackDetail = ref<ICashbackDetail | null>(null);
const router = useRouter();

const yearsOptions = computed(() => {
  return availableYears.value?.map(year => {
    return {
      label: String(year),
      value: String(year)
    };
  });
});

function onRowClick(month: ISummaryV2) {
  if (month.isDisabled) return;
  selectedMonth.value = month;
  isSideSheetOpen.value = true;
}

function onBack() {
  router.back();
}

async function onChange(value: string) {
  selectedYear.value = value;
  await fetchCashbackDetails(selectedYear.value);
}

async function fetchCashbackDetails(year: string, setSelectedYear = false) {
  hasError.value = false;
  try {
    isLoading.value = true;

    const data = await getCashbackDetails(year);

    availableYears.value = data.availableYears;
    cashbackDetail.value = data;

    if (setSelectedYear && !selectedYear.value && data.availableYears.length) {
      selectedYear.value = availableYears.value[0];
    }
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await fetchCashbackDetails(selectedYear.value, true);
});

return { __sfc: true,isLoading, hasError, selectedYear, selectedMonth, isSideSheetOpen, availableYears, cashbackDetail, router, yearsOptions, onRowClick, onBack, onChange, fetchCashbackDetails, NavBar, Heading, BaseText, FilterSelect, Row, SkeletonLoader, HelperViewStatus, BackButton, ShowMoneyToggleButton, CashbackSideSheet, Money }
}

})